import { tv, type VariantProps } from 'tailwind-variants';
export type MlCopyBlockVariants = VariantProps<typeof mlCopyBlock>;

const mlCopyBlock = tv({
  base: '',
  slots: {
    children: 'flex flex-col text-skin-tertiary',
  },
  variants: {
    alignment: {
      left: {
        base: 'text-left',
        children: 'items-start gap-10',
      },
      center: {
        base: 'text-center',
        children: 'items-center',
      },
      right: {
        base: 'text-right',
        children: 'items-end',
      },
    },
  },

  compoundVariants: [],
});

export default mlCopyBlock;
